import {PageEvent} from '@spartacus/storefront';

export class CheckoutDataEntryPageEvent extends PageEvent {}
